import React from "react";
import { KamiProvider } from "./context/KamiContext";
import ObserverRingPage from "./pages/ObserverRingPage";

function App() {
  return (
    <KamiProvider>
      <ObserverRingPage />
    </KamiProvider>
  );
}

export default App;
